// frontend_new/src/pages/Logout.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircleIcon, ArrowRightEndOnRectangleIcon } from '@heroicons/react/24/outline';

const Logout = () => {
  const navigate = useNavigate();

  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center p-4 bg-surfaceMuted overflow-y-auto">
      <div className="bg-white rounded-[24px] shadow-shadowAccess p-8 w-full max-w-[400px] text-center">
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 bg-[rgba(16,185,129,0.15)] rounded-full flex items-center justify-center">
            <CheckCircleIcon className="w-8 h-8 text-semanticPass" />
          </div>
        </div>

        <h1 className="text-textPrimary font-bold" style={{ fontSize: '1.5rem' }}>
          Successfully Logged Out
        </h1>
        <p className="text-textSecondary mt-2 mb-6" style={{ fontSize: '0.875rem' }}>
          Thank you for using Data Modeling Copilot. Your session has been securely ended.
        </p>

        <button
          onClick={() => navigate('/')}
          className="w-full flex items-center justify-center py-3 px-4 rounded-radiusSm text-sm font-semibold text-white bg-actionPrimary hover:bg-actionPrimaryHover focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-accent transition-colors duration-150"
        >
          <ArrowRightEndOnRectangleIcon className="w-5 h-5 mr-2" />
          Return to Home
        </button>

        <div className="pt-4 mt-4 border-t border-headerBorder">
          <p className="text-textSecondary leading-relaxed" style={{ fontSize: '0.75rem' }}>
            You can sign in again anytime to access your workspace and continue your data engineering projects.
          </p>
        </div>
      </div>

      <div className="mt-8 text-center">
        <p className="text-textSecondary" style={{ fontSize: '0.8rem' }}>
          © {new Date().getFullYear()} Bigtapp Analytics. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default Logout;
